import { render, staticRenderFns } from "./InsuranceFees.vue?vue&type=template&id=dd56a6e2&"
import script from "./InsuranceFees.vue?vue&type=script&lang=js&"
export * from "./InsuranceFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports